import _ from "lodash";

const DEFAULT_REPEAT = 1;
export const onHandleRepeatChange = ({
  event,
  setRepeat = () => undefined,
}) => {
  const value = _.chain(event).get(["target", "value"]).toInteger().value();
  setRepeat(value);
};

export const onHandleRepeatBlur = ({
  event,
  setRepeat = () => undefined,
  onHandleChangeValue = () => undefined,
}) => {
  const value = _.chain(event).get(["target", "value"]).toInteger().value();
  if (value <= 0 || _.isNaN(value)) {
    setRepeat(DEFAULT_REPEAT);
    onHandleChangeValue({ key: "repeat", value: DEFAULT_REPEAT });
  } else {
    onHandleChangeValue({ key: "repeat", value });
  }
};
